import { UseCase } from "../../base";
import { Product } from "../../domain/models";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ProductRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetProductsUsecase implements UseCase<void, Product[]> {

  constructor(private productRepository: ProductRepository) {
  }

  execute(params: void): Observable<Product[]> {
    return this.productRepository.getProducts();
  }

}
